// src/pages/ContactPage.js
import React from "react";

function ContactPage() {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Contact</h1>
      <p>
        You can reach our team at <strong>support@afi360.io</strong> (placeholder).
        A full contact form and support details will be added here.
      </p>
    </div>
  );
}

export default ContactPage;
